/**
 * @ngInject
 */
function Directive() {
  return {
    scope: {},
    bindToController: {
      newrelicActionSource: '@',
      displayView: '@'
    },
    controller: require('./controller.js'),
    controllerAs: 'fontpackCardListController',
    restrict: 'E',
    replace: true,
    transclude: true,
    templateUrl: '/angular_templates/directives/adobe_fonts_fontpack_card_list.html'
  };
}

module.exports = Directive;
